import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import { differenceInMinutes, format } from 'date-fns';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import setUiMessage from '../../Utilities/Tostify';
import { useSelector } from 'react-redux';
import Button from '../Button';

function ProofOfAppPopup({
  handleClose,
  patientId,
  appId,
  visitId,
  soapId,
  noteType,
}) {
  const { user } = useSelector((state) => state.auth);
  const [allData, setAlldata] = useState([]);
  const [sessTopic, setSessTopic] = useState('');
  const [serFreeq, setSerFreeq] = useState('weekly');
  useEffect(() => {
    (async () => {
      const response = await post(
        'api/patient/progressNote/getProofOfAppData',
        {
          patientId: patientId,
          soapId: soapId,
          visitId: visitId,
          appId: appId,
          noteType: noteType,
        }
      );
      if (response.status === 200) {
        setAlldata(response.data);
      }
    })();
  }, [patientId, appId, visitId, soapId, noteType]);

  const handlePrintPoa = async () => {
    if (!sessTopic) {
      setUiMessage('war', 'Session Topic is required.');
      return;
    }
    const response = await post('api/patient/progressNote/printProofOfApp', {
      patientId: patientId,
      appointmentId: appId,
      visitId: visitId,
      content: allData,
      sessTopic: sessTopic,
      serFreeq: serFreeq,
      userloginId: user?.id,
      noteType: noteType,
      priscbFacilityOther: allData?.prescribPhysician,
    });

    if (response.status === 200) {
      if (response.data?.status === 'success') {
        const pdfUrl = response.data?.pdfFileName;
        if (pdfUrl) {
          const popupWindow = window.open(
            pdfUrl,
            '',
            'height=800,width=750,resizable=0,fullscreen=0,titlebar=0,menubar=0,toolbar=0,status=0,scrollbars=1'
          );

          if (popupWindow) {
            popupWindow.onload = function () {
              popupWindow.focus();
              popupWindow.print();
            };
          } else {
            setUiMessage(
              'err',
              'Popup blocked! Please check if your browser is blocking popups.'
            );
          }
        } else {
          console.error('PDF URL is not defined.');
        }
      } else if (response.data?.status === 'pdffail') {
        setUiMessage('err', 'PDF file not generated');
      } else {
        setUiMessage('err', 'Print proof of appointment failed.');
      }
    } else {
      setUiMessage('err', `Server error: ${response.status}`);
      console.error('Server error:', response);
    }
  };

  const handleEmailPoa = async () => {
    if (!sessTopic) {
      setUiMessage('war', 'Session Topic is required.');
      return;
    }
    const response = await post('api/patient/progressNote/emailProofOfApp', {
      patientId: patientId,
      appointmentId: appId,
      visitId: visitId,
      content: allData,
      sessTopic: sessTopic,
      serFreeq: serFreeq,
      userloginId: user?.id,
      noteType: noteType,
    });

    if (response.status === 200) {
      if (response.data?.status === 'success') {
        //const pdfUrl = response.data?.pdfFileName;
        setUiMessage('suc', `Proof of appointment has been sent.`);
      } else if (response.data?.status === 'emailfail') {
        setUiMessage(
          'err',
          `Proof of appointment email not sent, please contact to administrator.`
        );
      } else {
        setUiMessage(
          'err',
          `Somthing went wrong, please contact to administrator.`
        );
      }
    } else {
      setUiMessage('err', `Server error: ${response.status}`);
      console.error('Server error:', response);
    }
  };

  return (
    <div className="modalBackground">
      <div className="left pov-main-container">
        <div className="flex-sec justify-between item-center clear-left10">
          <span className="hdr-dhng">Proof of Appointment</span>
          <Button variant="circle" onClick={handleClose}>
            X
          </Button>
        </div>
        <div className="left main-contnr-bdy">
          <div className="left main-contnr-rw">
            <div className="left main-cntr-hlf-rw">
              <span className="left popup-lbl">Patient name:</span>
              <span className="left popup-val">{allData?.patientName}</span>
            </div>
            <div className="left main-cntr-hlf-rw">
              <span className="left popup-lbl">Prescribing physician:</span>
              <span className="left popup-val">
                {allData?.prescribPhysician}
              </span>
            </div>
          </div>
          <div className="left main-contnr-rw">
            <div className="left main-cntr-hlf-rw">
              <span className="left popup-lbl">Service date:</span>
              <span className="left popup-val">
                {allData?.serviceDate
                  ? format(new Date(allData?.serviceDate), DEFAULT_DATE_FORMATE)
                  : ''}
              </span>
            </div>
            <div className="left main-cntr-hlf-rw">
              <span className="left popup-lbl">Name of therapist:</span>
              <span className="left popup-val">{allData?.nameOfTherapist}</span>
            </div>
          </div>
          <div className="left main-contnr-rw">
            <div className="left main-cntr-hlf-rw">
              <span className="left popup-lbl">Start/ End:</span>
              <span className="left popup-val">
                {allData?.startTime
                  ? format(new Date(allData?.startTime), 'hh:mm a')
                  : ''}
                -{' '}
                {allData?.endTime
                  ? format(new Date(allData?.endTime), 'hh:mm a')
                  : ''}
              </span>
            </div>
            <div className="left main-cntr-hlf-rw">
              <span className="left popup-lbl">Type of visit:</span>
              <span className="left popup-val">{allData?.tovName}</span>
            </div>
          </div>
          <div className="left main-contnr-rw">
            <div className="left main-cntr-hlf-rw">
              <span className="left popup-lbl">Duration:</span>
              <span className="left popup-val">
                {differenceInMinutes(
                  new Date(allData?.endTime),
                  new Date(allData?.startTime)
                )}{' '}
                minutes
              </span>
            </div>
            <div className="left main-cntr-hlf-rw">
              <span className="left popup-lbl">Location:</span>
              <span className="left popup-val">{allData?.locationName}</span>
            </div>
          </div>
          <div className="left main-contnr-rw">
            <span className="left popup-lbl">Session Topic:</span>
            <span className="left popup-val">
              <textarea
                className="main-contnr-txtarea"
                value={sessTopic || ''}
                onChange={(e) => setSessTopic(e.target.value)}
              ></textarea>
            </span>
          </div>
          <div className="left main-contnr-rw">
            <div className="left main-cntr-hlf-rw">
              <span className="left popup-lbl">Service frequency:</span>
              <span className="left popup-val">
                <select
                  className="left chzn-select"
                  style={{ width: '120px' }}
                  value={serFreeq || 'weekly'}
                  onChange={(e) => setSerFreeq(e.target.value)}
                >
                  <option value="weekly">Weekly</option>
                  <option value="bi-monthly">Bi-Monthly</option>
                  <option value="monthly">Monthly</option>
                </select>
              </span>
            </div>
            <div className="left main-cntr-hlf-rw">
              <span className="left popup-lbl">Next Appointment:</span>
              <span className="left popup-val">
                {allData?.nextVisit
                  ? format(new Date(allData?.nextVisit), DEFAULT_DATE_FORMATE)
                  : ''}
              </span>
            </div>
          </div>
          <div className="left main-contnr-rw">&nbsp;</div>
        </div>
        <div className="main-contnr-ftr flex-sec justify-between item-center">
          <span className="left sign-lbl">{allData?.signStr}</span>
          <div className="flex-sec gap10">
            <Button variant="outline" onClick={handleClose}>
              Close
            </Button>
            <Button variant="secondary" onClick={handlePrintPoa}>
              Print
            </Button>
            {/* <span className="right actn-yes clear-right width-unset">Fax</span> */}
            <Button variant="primary" onClick={handleEmailPoa}>
              Email
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProofOfAppPopup;
